// extracted by mini-css-extract-plugin
export default {"productGallery":"OJ-z","inQuickShop":"PJ-z"};